module.exports = __webpack_public_path__ + "static/media/logo.532d1daa.png";